<template>
  <div>
    <modal
      :show.sync="initialInfoModal.show"
      :closeOnClick="false"
      modal-classes="modal-dialog-centered"
    >
      <div class="vld-parent" ref="modalInitialInfo">
        <div class="py-3 text-center">
          <img
            class="mx-auto d-block img-fluid mb-3"
            width="50%"
            src="/img/brand/logo_stars_black.png"
          />
          <div class="text-center">
            <h4 class="heading mt-1">Seja bem vindo ao portal Stars!</h4>
            <p>
              Complete as informações para finalizar seu cadasto. Você poderá
              atualizá-lo a qualquer momento.
            </p>
            <base-progress
              type="warning"
              :striped="true"
              :height="4"
              :showPercentage="false"
              :value="initialInfoModal.percentage"
            />
          </div>
        </div>
        <form role="form" @submit="handleSubmit">
          <div v-show="initialInfoModal.step == 1">
            <base-input
              label="Nome"
              v-model="model.investor.name"
              placeholder="Nome completo"
            />
            <base-input
              label="Data de nascimento"
              type="date"
              v-model="model.investor.birthday"
              placeholder="Data de nascimento"
            />
          </div>
          <div v-show="initialInfoModal.step == 2">
            <estados
              estadoLabel="Estado"
              cidadeLabel="Cidade"
              :selectedEstado="model.investor.state"
              :selectedCidade="model.investor.city"
              @inputEstado="model.investor.state = $event"
              @inputCidade="model.investor.city = $event"
            />
            <base-input
              label="Telefone para contato (opcional)"
              v-model="model.investor.phone"
              placeholder="Telefone com DDD"
              v-mask="'(##) #####-####'"
            />
          </div>
          <base-alert
            v-if="initialInfoModal.error"
            class="text-center"
            type="danger"
          >
            {{ initialInfoModal.error }}
          </base-alert>
          <div class="row">
            <div class="col-lg-12">
              <base-button
                type="default"
                class="mt-3"
                :btn-icon-only="true"
                icon="ni ni-bold-left"
                @click="previousStep"
                v-show="initialInfoModal.step > 1"
              />
              <base-button
                type="default"
                class="mt-3 float-right"
                :btn-icon-only="true"
                icon="ni ni-bold-right"
                @click="nextStep"
                v-if="initialInfoModal.step < 2"
              />
              <base-button
                v-else
                nativeType="submit"
                type="warning"
                class="mt-3 float-right"
                >Concluir cadastro
              </base-button>
            </div>
          </div>
        </form>
      </div>
    </modal>
    <modal
      :show.sync="notValidatedModal.show"
      :closeOnClick="false"
      modal-classes="modal-dialog-centered"
      body-classes="pb-0"
    >
      <div class="py-3 text-center">
        <img
          class="mx-auto d-block img-fluid mb-3"
          width="50%"
          src="/img/brand/logo_stars_black.png"
        />
        <div class="text-center">
          <hr class="my-4" />
          <h4 class="heading mt-1 mb-4">
            Olá,
            <span class="text-warning">{{
              model.investor.name || "investidor"
            }}</span
            >!
          </h4>
          <p class="text-md">
            Seu cadastrado como
            <span class="text-warning">investidor STARS</span> foi concluído e
            enviado para validação
            <i
              class="fas fa-info-circle"
              title="Por questões de segurança, apenas contas validadas podem acessar as funcionalidades do Portal STARS"
            ></i>
          </p>
          <p class="text-sm">
            O acesso ao portal será liberado assim que sua conta for validada
            pela nossa equipe. Não se preocupe, isso deverá acontecer em breve.
            Em caso de dúvidas, sinta-se livre para
            <base-button
              type="danger"
              class="ml-auto"
              size="sm"
              @click="$router.push('/investidor/suporte')"
              >Contatar o suporte
            </base-button>
          </p>
          <p class="text-right mt-4">
            Cordialmente,<br />
            <span class="font-weight-600"
              >Equipe <span class="text-warning">STARS</span></span
            >.
          </p>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api.js";
import { logout } from "@/services/auth.js";

export default {
  name: "initial-info-modal",
  props: {
    startupName: {
      type: String,
    },
  },
  data() {
    return {
      model: {
        investor: {
          name: "",
          state: "",
          city: "",
          phone: "",
        },
      },
      initialInfoModal: {
        show: false,
        error: "",
        percentage: 0,
        step: 1,
      },
      notValidatedModal: {
        show: false,
      },
    };
  },
  async mounted() {
    try {
      const { data: investor } = await api.get("/investors");
      if (!investor) this.initialInfoModal.show = true;
      else {
        this.model.investor.name = investor.name;
        if (!investor.account_validated) this.notValidatedModal.show = true;
        this.$emit("investor_name", investor.name);
        this.$emit("investor_validated", investor.account_validated);
      }
    } catch (e) {
      this.$toasted.error(
        "Ocorreu um erro ao recuperar as informações do usuário"
      );
      logout();
      this.$router.push("/");
    }
  },
  methods: {
    async handleSubmit(e) {
      e.preventDefault();
      const phoneRegex = /^\(\d{2}\) \d{5}-\d{4}$/;

      if (!this.model.investor.state || !this.model.investor.city) {
        this.setError();
        return;
      }
      if (
        this.model.investor.phone &&
        !phoneRegex.test(this.model.investor.phone)
      ) {
        this.setError("Telefone inválido. Verifique o número digitado.");
        return;
      }
      const loader = this.$loading.show({
        container: this.$refs.modalInitialInfo,
        width: 128,
        height: 128,
      });
      const data = this.model.investor;
      try {
        await api.post("/investors", data);
        this.initialInfoModal.percentage += 50;
        this.$emit("investor_name", this.model.investor.name);
        this.initialInfoModal.show = false;
        this.$toasted.show("Informações de usuário salvas com sucesso");
        this.notValidatedModal.show = true;
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao salvar as informações de usuário"
        );
        this.setError("Ocorreu um erro ao registar sua conta.");
      } finally {
        loader.hide();
      }
    },
    nextStep(e) {
      e.preventDefault();
      if (this.initialInfoModal.step == 1) {
        this.model.investor.name = this.model.investor.name.trim();
        if (!this.model.investor.name || !this.model.investor.birthday) {
          this.setError();
          return;
        }
      }
      this.initialInfoModal.error = "";
      this.initialInfoModal.step++;
      this.initialInfoModal.percentage += 50;
    },
    previousStep(e) {
      e.preventDefault();
      this.initialInfoModal.error = "";
      this.initialInfoModal.step--;
      this.initialInfoModal.percentage -= 50;
    },
    setError(msg = "Preencha os dados para continuar.") {
      this.initialInfoModal.error = msg;
    },
  },
};
</script>
